var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 7,
    viewBox: "0 0 28 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4896 0.000244141C1.97013 0.000244141 1.35424 0.501886 0.846223 1.34524C0.31673 2.21867 0.000854492 3.29996 0.000854492 4.23896C0.000854492 5.6136 0.768854 6.99989 2.48974 6.99989C4.20857 6.99989 4.97863 5.6136 4.97863 4.23896C4.97863 3.29996 4.6629 2.21867 4.13597 1.34524C3.62319 0.501886 3.00736 0.000244141 2.4896 0.000244141ZM15.929 2.06267H17.6712V6.62503H19.5379V2.06267H21.2794V0.375029H15.929V2.06246V2.06267ZM25.2616 2.06267H27.9994V0.375029H25.2616C22.7464 0.375029 21.4031 1.63117 21.4031 3.49981C21.4031 5.36846 22.7464 6.62503 25.2616 6.62503H27.9994V4.93746H25.2616C24.0975 4.93746 23.3323 4.51953 23.3323 3.50003C23.3323 2.48053 24.0975 2.06267 25.2616 2.06267ZM12.1323 0.375029L11.1375 4.10539L10.1427 0.375029H6.84523V6.62503H8.71118V1.54146L10.0673 6.62503H12.2077L13.5645 1.53839V6.62503H15.4312V0.375029H12.1323Z",
    fill: "#E30613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMts);
export default __webpack_public_path__ + "static/media/mts.c93cac7dd91ebb7fdc9e4fcf3910ab93.svg";
export { ForwardRef as ReactComponent };